/**
 * Minimal AR access rules for the shell (plan 01 section 4.3).
 *
 * AR has one privileged role today: `admin` opens `/admin/*`. Everything else
 * is open to any signed-in user, which matches the old sidebar's `adminOnly`
 * behaviour. AP's richer role model is deliberately not ported.
 */
import { defaultCanAccess } from './navigation'

export function isAdmin(roles?: readonly string[] | null): boolean {
  return !!roles?.includes('admin')
}

/** Whether a session with `roles` may open `path`. */
export function canAccess(path: string, roles?: readonly string[] | null): boolean {
  return defaultCanAccess(path, roles)
}
